import React from 'react';
import { Link } from '@reach/router';
import PropTypes from 'prop-types';
import { Refresh } from '@material-ui/icons';
import Loader from '../Loader/Loader';
import Button from '../Button/Button';

const ResourceCard = props => {
  return (
    <div className="w-1/2 bg-white flex justify-between items-center m-8 rounded shadow p-4 relative">
      <Loader className="flex" loading={props.loading}>
        <div className="font-medium text-xl">{props.name}</div>
        <div className="flex items-center">
          {props.hasDrafts ? (
            <Link to={props.draftDestination}>
              <Button type="blue" className="h-8">
                Review Drafts
              </Button>
            </Link>
          ) : (
            <Button disabled className="h-8">
              No Drafts
            </Button>
          )}
          <Button
            type="transparent"
            onClick={props.refreshStatus}
            className="p-0-important shadow-none-important h-6 ml-8">
            <Refresh className="text-darkGrey" />
          </Button>
        </div>
      </Loader>
    </div>
  );
};

ResourceCard.propTypes = {
  name: PropTypes.string.isRequired,
  draftDestination: PropTypes.string.isRequired,
  hasDrafts: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  refreshStatus: PropTypes.func,
};

export default  ResourceCard;
